import { render, staticRenderFns } from "./organization-management.html?vue&type=template&id=e246e32a&"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js&"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports